<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData, storeSelectedIcon, storeHM } from '../../library/scripts/Store.svelte'
	import { get_initial_navbar_values, get_blocks } from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	let icon1Color = globals.colorDark
	let icon2Color = globals.colorDark
	let iconAlignL = globals.colorDark
	let iconAlignC = globals.colorDark
	let iconAlignR = globals.colorDark
	let mainTool = globals.mainTool
	let subTool = globals.subTool

	let mainToolHover = globals.mainToolHover
	let subToolHover = globals.subToolHover

	let elementID
	let config

	// if social is present in config file -> show tool tip tool
	let toolTip = false

	//navbar fixed
	let fixedNavbar = false

	//selector ids
	const idColor1 = '101'
	const idColor2 = '102'
	const idColor3 = '103'
	const idColor4 = '104'
	const idColor5 = '105'
	const idColor6 = '106'
	const idColor7 = '107'
	const idColor8 = '108'
	const idColor9 = '109'
	const idColor10 = '110'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPaddingLeft = '5'
	const idPaddingRight = '6'
	const idBorderWidth = '7'
	const idShadowY = '8'
	const idShadowBlur = '9'

	//set icons
	let icon1 = false
	let icon2 = false

	let generalTool = false
	let showTool0 = false
	let showTool1 = false
	let showTool2 = false
	let showTool3 = false
	let showTool4 = false
	let showTool5 = false
	let showTool6 = false

	//icon selected
	let selectedIcon

	//show border tools
	let iconSelected = false

	let shaderChangeOrder = false

	//css selections
	let selectedLayoutOrder,
		selectedPosition,
		selectedWidth,
		selectedValign,
		selectedAlign,
		selectedMarginBottom,
		selectedMarginTop,
		selectedPaddingLeft,
		selectedPaddingRight,
		selectedBGcolor,
		selectedBGopac,
		selectedFontSize,
		selectedFontWeight,
		selectedFontColor,
		selectedFontOpac,
		selectedFontHover,
		selectedFontHoverOpac,
		selectedBorderTopWidth,
		selectedBorderTopColor,
		selectedBorderTopStyle,
		selectedBorderBottomWidth,
		selectedBorderBottomColor,
		selectedBorderBottomStyle,
		selectedBorderWidth = 0,
		selectedShadowColor,
		selectedShadowOffsetY,
		selectedShadowBlur,
		selectedOpacShadow,
		selectedTTBG,
		selectedTTFC,
		selectedHSC,
		selectedHFC,
		selectedHPOP

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			if (value.social) toolTip = true
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	let selectedStoreIcon
	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//set the 'fixed' checkbox on load
	config.blocks.forEach((block, index) => {
		if (block.blockName === 'navbar') {
			config.blocks[index].position = block.position
			if (config.blocks[index].position === 'fixed') fixedNavbar = true
			else fixedNavbar = false
			storeData.set(config)
		}
	})

	$: if (fixedNavbar) {
		config.blocks.forEach((block, index) => {
			if (block.blockName === 'navbar') {
				config.blocks[index].position = 'fixed'
				storeData.set(config)
			}
		})
	}

	$: if (!fixedNavbar) {
		config.blocks.forEach((block, index) => {
			if (block.blockName === 'navbar') {
				config.blocks[index].position = 'relative'
				storeData.set(config)
			}
		})
	}

	//set the initial css values from config.json
	$: if (elementID === 'Navbar') {
		const values = get_initial_navbar_values(config)
		selectedLayoutOrder = values[0]
		selectedPosition = values[1]
		selectedWidth = values[2]
		selectedValign = values[3]
		selectedAlign = set_icon_initial_value(values[4])
		selectedMarginBottom = values[5]
		selectedMarginTop = values[6]
		selectedPaddingLeft = values[7]
		selectedPaddingRight = values[8]
		selectedBGcolor = values[9]
		selectedBGopac = values[10]
		selectedFontSize = values[11]
		selectedFontWeight = values[12]
		selectedFontColor = values[13]
		selectedFontOpac = values[14]
		selectedFontHover = values[15]
		selectedFontHoverOpac = values[16]
		selectedBorderTopWidth = values[17]
		selectedBorderTopColor = values[18]
		selectedBorderTopStyle = values[19]
		selectedBorderBottomWidth = values[20]
		selectedBorderBottomColor = values[21]
		selectedBorderBottomStyle = values[22]
		selectedShadowColor = values[23]
		selectedShadowOffsetY = values[24]
		selectedShadowBlur = values[25]
		selectedOpacShadow = values[26]
		selectedTTBG = values[27]
		selectedTTFC = values[28]
		selectedHSC = values[29]
		selectedHFC = values[30]
		selectedHPOP = values[31]

		if (selectedBorderTopWidth > 0) {
			icon1 = true
			set_icon_color('top')
		}
		if (selectedBorderBottomWidth > 0) {
			icon2 = true
			set_icon_color('bottom')
		}
	}

	$: if (!icon1 && !icon2) iconSelected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedBorderTopWidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedBorderBottomWidth

	const set_icon_color = (c) => {
		if (c === 'top') icon1Color = iconHover
		if (c === 'bottom') icon2Color = iconHover
	}

	const set_css_tag = (cssTag, cmd) => {
		if (cmd === 'bg') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') config.blocks[index].backgroundColor = cssTag
			})
		}

		if (cmd === 'bT') {
			if (icon1) {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderTopWidth = 1
						config.blocks[index].borderTopColor = cssTag
						icon1Color = iconHover
					}
				})
			} else {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderTopWidth = 0
						icon1Color = iconColor
					}
				})
			}
		}

		if (cmd === 'bB') {
			if (icon2) {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderBottomWidth = 1
						config.blocks[index].borderBottomColor = cssTag
						icon2Color = iconHover
					}
				})
			} else {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderBottomWidth = 0
						icon2Color = iconColor
					}
				})
			}
		}

		if (cmd === 'ttBG') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') config.blocks[index].ttBG = cssTag
			})
		}

		if (cmd === 'ttFC') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') config.blocks[index].ttFC = cssTag
			})
		}

		if (cmd === 'HSC') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') config.blocks[index].HSC = cssTag
			})
		}

		if (cmd === 'HFC') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') config.blocks[index].HFC = cssTag
			})
		}

		if (cmd === 'HPOP') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') config.blocks[index].HPOP = cssTag
			})
		}

		if (cmd === 'bColor' || cmd === 'bOpacity') {
			if (icon1 && selectedIcon === 'icon1') {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderTopColor = cssTag
					}
				})
			}
			if (icon2 && selectedIcon === 'icon2') {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderBottomColor = cssTag
					}
				})
			}
		}

		if (cmd === 'bWidth') {
			if (icon1 && selectedIcon === 'icon1') {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderTopWidth = cssTag
					}
				})
			}
			if (icon2 && selectedIcon === 'icon2') {
				config.blocks.forEach((block, index) => {
					if (block.blockName === 'navbar') {
						config.blocks[index].borderBottomWidth = cssTag
					}
				})
			}
		}

		if (cmd === 'sC') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') {
					config.blocks[index].shadowColor = cssTag
				}
			})
		}

		if (cmd === 'sY') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') {
					config.blocks[index].shadowOffsetY = cssTag
				}
			})
		}

		if (cmd === 'sB') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') {
					config.blocks[index].shadowBlur = cssTag
				}
			})
		}

		if (cmd === 'fontColor') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') {
					config.blocks[index].fontColor = cssTag
				}
			})
		}

		if (cmd === 'hoverColor') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') {
					config.blocks[index].fontHover = cssTag
				}
			})
		}

		if (cmd === 'flexAlign') {
			config.blocks.forEach((block, index) => {
				if (block.blockName === 'navbar') {
					config.blocks[index].align = cssTag
				}
			})
		}

		storeData.set(config)
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bg')
	}

	const set_font_color = (e) => {
		set_css_tag(e.detail.color, 'fontColor')
	}

	const set_hover_color = (e) => {
		set_css_tag(e.detail.color, 'hoverColor')
	}

	const set_margin_top = (e) => {
		config.blocks.forEach((block, index) => {
			if (block.blockName === 'navbar') {
				config.blocks[index].marginTop = e.detail.value
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		config.blocks.forEach((block, index) => {
			if (block.blockName === 'navbar') {
				config.blocks[index].marginBottom = e.detail.value
				storeData.set(config)
			}
		})
	}

	const set_padding_left = (e) => {
		config.blocks.forEach((block, index) => {
			if (block.blockName === 'navbar') {
				config.blocks[index].paddingLeft = e.detail.value
				storeData.set(config)
			}
		})
	}

	const set_padding_right = (e) => {
		config.blocks.forEach((block, index) => {
			if (block.blockName === 'navbar') {
				config.blocks[index].paddingRight = e.detail.value
				storeData.set(config)
			}
		})
	}

	const set_icon_1 = () => {
		iconSelected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_2 = () => {
		iconSelected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const change_order = async (block, direction) => {
		let changeOrder = true
		let blocks = get_blocks(config)
		blocks.forEach((bl, index) => {
			if (bl.blockName === block) {
				if (config.blocks[index].layoutOrder === 0 && direction === 'up') {
					changeOrder = false
				}
				if (config.blocks[index].layoutOrder === blocks.length - 1 && direction === 'down') {
					changeOrder = false
				}
			}
		})

		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			storeData.set(reorder)
			shaderChangeOrder = false
		}
	}

	const set_icon_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconAlignL = iconHover
				iconAlignC = iconColor
				iconAlignR = iconColor
				return
			}
			if (v === 'center') {
				iconAlignL = iconColor
				iconAlignC = iconHover
				iconAlignR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconAlignL = iconColor
				iconAlignC = iconColor
				iconAlignR = iconHover
				return
			}
		}
	}

	const set_flex_align_left = () => {
		set_css_tag('flex-start', 'flexAlign')
	}

	const set_flex_align_center = () => {
		set_css_tag('center', 'flexAlign')
	}

	const set_flex_align_right = () => {
		set_css_tag('flex-end', 'flexAlign')
	}

	const set_tool_tip_bg = (e) => {
		set_css_tag(e.detail.color, 'ttBG')
	}

	const set_tool_tip_fc = (e) => {
		set_css_tag(e.detail.color, 'ttFC')
	}

	const set_hamburger_HSC = (e) => {
		set_css_tag(e.detail.color, 'HSC')
	}

	const set_hamburger_HFC = (e) => {
		set_css_tag(e.detail.color, 'HFC')
	}

	const set_hamburger_HPOP = (e) => {
		set_css_tag(e.detail.color, 'HPOP')
	}

	const open_tool = (t) => {
		switch (t) {
			case 'generalTool':
				generalTool = generalTool === true ? false : true
				showTool3 = false
				showTool4 = false
				showTool5 = false
				showTool6 = false
				storeHM.set(false)
				break
			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool2 = false
				showTool5 = false
				showTool6 = false
				storeHM.set(false)
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool2 = false
				showTool5 = false
				showTool6 = false
				storeHM.set(false)
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				showTool0 = false
				showTool1 = false
				showTool5 = false
				showTool6 = false
				storeHM.set(false)
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool = false
				showTool4 = false
				showTool5 = false
				showTool6 = false
				storeHM.set(false)
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				generalTool = false
				showTool3 = false
				showTool5 = false
				showTool6 = false
				storeHM.set(false)
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				showTool0 = false
				showTool2 = false
				showTool1 = false
				showTool6 = false
				storeHM.set(false)
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				if (showTool6) storeHM.set(true)
				else storeHM.set(false)
				showTool0 = false
				showTool2 = false
				showTool1 = false
				showTool5 = false
				break
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
	})
</script>

{#if config}
	<main use:styles={{ width }}>
		<div
			class="part_title mainTool"
			on:click={() => open_tool(0)}
			on:keydown={() => open_tool(0)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			LAYOUT POSITION
		</div>
		{#if showTool0}
			<div transition:slide={{ duration: 500 }}>
				<div class="icon_container">
					<div
						class="icon arrow_down"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order('navbar', 'down')}
						on:keydown={() => change_order('navbar', 'down')}
					/>
					<div
						class="icon arrow_up"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order('navbar', 'up')}
						on:keydown={() => change_order('navbar', 'up')}
					/>
				</div>
			</div>
		{/if}
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				CONTAINER
			</div>

			{#if showTool1}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool')}
						on:keydown={() => open_tool('generalTool')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool}
						<div transition:slide={{ duration: 500 }}>
							<div class="fixed_navbar" use:styles={{ fsXS }}>
								fix navbar
								<input id="setbackground" type="checkbox" bind:checked={fixedNavbar} />
							</div>

							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_bg_color}
								on:setopacity={set_bg_color}
								on:settransparent={set_bg_color}
								transparent="1"
								ID={idColor1}
								selectedColor={selectedBGcolor}
								initialValue={selectedBGopac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idMarginTop}
								range="5"
								initialValue={selectedMarginTop}
								on:sizechange={set_margin_top}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMarginBottom}
								range="5"
								initialValue={selectedMarginBottom}
								on:sizechange={set_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding Left</div>
							<SizeSelector
								ID={idPaddingLeft}
								range="5"
								initialValue={selectedPaddingLeft}
								on:sizechange={set_padding_left}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding Right</div>
							<SizeSelector
								ID={idPaddingRight}
								range="5"
								initialValue={selectedPaddingRight}
								on:sizechange={set_padding_right}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(3)}
						on:keydown={() => open_tool(3)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon1"
									class="icon icon1"
									use:styles={{ icon, icon1Color, iconHover }}
									on:click={set_icon_1}
									on:keydown={set_icon_1}
								/>
								<div
									id="icon2"
									class="icon icon2"
									use:styles={{ icon, icon2Color, iconHover }}
									on:click={set_icon_2}
									on:keydown={set_icon_2}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
									<ColorSelector on:setcolor={set_border_color} on:setopacity={set_border_color} ID={idColor2} />

									<div class="sub_title" use:styles={{ fsXS }}>Border Width</div>
									<SizeSelector
										ID={idBorderWidth}
										range="20"
										unit="px"
										initialValue={selectedBorderWidth}
										on:sizechange={set_border_width}
									/>
								</div>
							{/if}
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(4)}
						on:keydown={() => open_tool(4)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool4}
						<div transition:slide={{ duration: 500 }}>
							<ColorSelector
								on:setcolor={set_shadow_color}
								on:setopacity={set_shadow_color}
								ID={idColor3}
								selectedColor={selectedShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idShadowY}
								range="20"
								initialValue={selectedShadowOffsetY}
								on:sizechange={set_offset_y}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector ID={idShadowBlur} range="20" initialValue={selectedShadowBlur} on:sizechange={set_blur} />
						</div>
					{/if}
				</div>
			{/if}
		</section>

		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(2)}
				on:keydown={() => open_tool(2)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				LINK
			</div>
			{#if showTool2}
				<div transition:slide={{ duration: 500 }}>
					<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
					<ColorSelector
						on:setcolor={set_font_color}
						ID={idColor4}
						selectedColor={selectedFontColor}
						initialValue={selectedFontOpac}
					/>

					<div class="sub_title" use:styles={{ fsXS }}>Hover Color</div>
					<ColorSelector
						on:setcolor={set_hover_color}
						on:setopacity={set_hover_color}
						ID={idColor5}
						selectedColor={selectedFontHover}
						initialValue={selectedFontHoverOpac}
					/>

					<div class="sub_title" use:styles={{ fsXS }}>Text Alignment</div>
					<div class="icon_container">
						<div
							id="fAlignL"
							class="icon txtAlignL"
							use:styles={{ icon, iconAlignL, iconHover }}
							on:click={set_flex_align_left}
							on:keydown={set_flex_align_left}
						/>

						<div
							id="fAlignC"
							class="icon txtAlignC"
							use:styles={{ icon, iconAlignC, iconHover }}
							on:click={set_flex_align_center}
							on:keydown={set_flex_align_center}
						/>

						<div
							id="fAlignR"
							class="icon txtAlignR"
							use:styles={{ icon, iconAlignR, iconHover }}
							on:click={set_flex_align_right}
							on:keydown={set_flex_align_right}
						/>
					</div>
				</div>
			{/if}

			{#if toolTip}
				<div
					class="part_title mainTool"
					on:click={() => open_tool(5)}
					on:keydown={() => open_tool(5)}
					use:styles={{ mainTool, mainToolHover, fsXS }}
				>
					TOOL-TIP
				</div>
				{#if showTool5}
					<div transition:slide={{ duration: 500 }}>
						<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
						<ColorSelector on:setcolor={set_tool_tip_bg} ID={idColor6} selectedColor={selectedTTBG} />

						<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
						<ColorSelector on:setcolor={set_tool_tip_fc} ID={idColor7} selectedColor={selectedTTFC} />
					</div>
				{/if}
			{/if}
		</section>

		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(6)}
				on:keydown={() => open_tool(6)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				HAMBURGER
			</div>

			{#if showTool6}
				<div transition:slide={{ duration: 500 }}>
					<div class="sub_title" use:styles={{ fsXS }}>Stroke Color</div>
					<ColorSelector on:setcolor={set_hamburger_HSC} ID={idColor8} selectedColor={selectedHSC} />

					<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
					<ColorSelector on:setcolor={set_hamburger_HFC} ID={idColor9} selectedColor={selectedHFC} />

					<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
					<ColorSelector on:setcolor={set_hamburger_HPOP} ID={idColor10} selectedColor={selectedHPOP} />
				</div>
			{/if}
		</section>
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsXS);
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.txtAlignL {
		background-color: var(--iconAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtAlignC {
		background-color: var(--iconAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtAlignR {
		background-color: var(--iconAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.fixed_navbar {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: var(--fsXS);
		color: white;
		height: 30px;
		padding: 10px 0px 10px 10px;
		margin-top: 10px;
		background-color: darkgreen;
	}

	input[type='checkbox'] {
		outline: none;
		margin-top: 5px;
		margin-left: 20px;
		padding: none;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
